export default __webpack_public_path__ + "static/media/Flower-Cake-3.a0815f92.jpg";